import $ from "jquery";
import Headroom from "headroom.js";

var mobileMenu = function() {
  $(".menu-trigger button").on("click", function(e) {
    if ($("body").hasClass("js-mobile-menu-open")) {
      $("body").removeClass("js-mobile-menu-open");
      $(this).html("Menu");
    } else {
      $("body").addClass("js-mobile-menu-open");
      $(this).html("Close");
    }
  });

  $(".menu-mobile a").on("click", function(e) {
    setTimeout(function() {
      $("body").removeClass("js-mobile-menu-open");
      $(".menu-trigger button").html("Menu");
    }, 500);
  });

  $(window).resize(function() {
    if ($(window).width() > 767) {
      $("body").removeClass("js-mobile-menu-open");
      $(".menu-trigger button").html("Menu");
    }
  });

  var mobileElement = document.querySelector(".header-mobile");
  var mobileheadroom  = new Headroom(mobileElement, {
    offset: 50
  });
  mobileheadroom.init();

};

export default mobileMenu;



// WEBPACK FOOTER //
// ./src/scripts/functions/mobilemenu.js